import { useFiltersLists } from "features/filters/store/lists";

function useProdutividadeFilters() {

  const { produtividade, loadings } = useFiltersLists();

  return {
    produtividade,
    isLoading: loadings.produtividade,
  };
}

export default useProdutividadeFilters;
